<template>
  <div class="skill-dive-session-empty">
    <div class="skill-dive-session-empty__title">
      You haven't used any Skill Dive hours yet.
    </div>
    <div class="skill-dive-session-empty__detail">
      Explore our
      <router-link :to="{ name: 'skill-dive' }">lab collections</router-link>
      and start your hands-on practice today.
    </div>
  </div>
</template>
<script>
export default {
  name: 'SkillDivePlanSessionEmpty',
}
</script>
<style lang="scss" scoped>
.skill-dive-session-empty {
  text-align: center;

  &__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 450;
    color: var(--white);
  }

  &__detail {
    font-size: 12px;
    line-height: 14px;
    font-weight: 450;
    color: var(--light-blue-gray);
  }
  a {
    color: var(--purple-light);
  }
}
</style>
